export const ButtonSize = {
	SMALL: "small",
	MEdIUM: "medium",
	LARGE: "large"
} as const;

export type ButtonSizeType = (typeof ButtonSize)[keyof typeof ButtonSize];
